import React, { useState } from "react";
import {
  Stack,
  styled,
  Link,
  Grid,
  Avatar,
  InputAdornment,
  FormControl,
  InputLabel,
  Button,
  MenuItem,
  Select,
  Fade,
  Divider,
} from "@mui/material";
import {
  TextField,
  Typography,
  makeStyles,
  Container,
  Modal,
  Backdrop,
} from "@material-ui/core";
import { colorTags } from "../../../constants/variants";
import { DropzoneArea } from "material-ui-dropzone";
import { DropzoneAreaBase } from "material-ui-dropzone";

import { useStyles } from "../../../App";
import {
  useGetFAQsQuery,
  useGetFAQByIdQuery,
  useCreateFAQRequestMutation,
  useUpdateFAQRequestMutation,
  useDeleteFAQRequestMutation,
} from "../../../features/api/apiSlice";
import { toast } from "react-toastify";

const useStyless = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dropzone: {
    minHeight: "50px !important",
    border: "1px dashed #006738",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: theme.spacing(2),
  },
  modalContent: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: theme.spacing(2),
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
    maxWidth: "90%",
    maxHeight: "90%",
    overflow: "auto",
    outline: "none",
  },
  modalTitle: {
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  modalBody: {
    marginTop: theme.spacing(2),
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
  modalActions: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#006738",
      },
      "&:hover fieldset": {
        borderColor: "#006738",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#006738",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#006738",
    },
  },
}));

const AddFAQ = ({ open, onClose, title, onSave }) => {
  const classes = useStyless();
  const classez = useStyles();
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [subject, setSubject] = useState("");
  const [customSubject, setCustomSubject] = useState("");
  const [
    createFAQRequest,
    {
      data,
      isLoading: isLoadingCreateRequest,
      isError: isErrorCreateRequest,
      isSuccess,
      error: errorCreateRequest,
    },
  ] = useCreateFAQRequestMutation();
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const handleSave = async (e) => {
    e.preventDefault();
    const data = {
      question,
      answer,
      subject: customSubject || subject,
      userId: user?.user_id,
    };
    await createFAQRequest(data)
      .then((res) => {
        toast.success("FAQ Added Successfully");
        console.log(res);
        setQuestion("");
        setAnswer("");
        setSubject([]);
      })
      .catch((err) => {
        toast.error("Something went wrong");
        console.log(err);
      });

    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={classes.modal}>
      <Fade in={open}>
        <div className={classes.modalContent}>
          <div className={classes.modalHead}>
            <Typography
              variant="h5"
              className={classes.modalTitle}
              style={{ fontWeight: "medium", color: colorTags.PRIMARY }}>
              {title}
            </Typography>
          </div>
          <Divider style={{ backgroundColor: "#00FF00" }} />
          <div className={classes.modalBody}>
            <TextField
              label="Question"
              variant="outlined"
              className={classes.textField}
              InputProps={{
                inputProps: {
                  maxLength: 500,
                },
              }}
              required
              placeholder="Maximum of 500 characters"
              fullWidth
              style={{ marginTop: "15px" }}
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />

            <FormControl
              color="success"
              fullWidth
              style={{ marginTop: "15px" }}>
              <InputLabel id="Routes" style={{}}>
                Subject
              </InputLabel>
              <Select
                className={classes.textField}
                label="Subject"
                variant="outlined"
                placeholder="Select Subject (50 characters)"
                color="success"
                InputProps={{
                  inputProps: {
                    maxLength: 50,
                  },
                }}
                // multiple
                value={subject}
                onChange={(e) => setSubject(e.target.value)}>
                {["Custom", "Coffee", "Textile", "Ship", "Plane", "Land"].map(
                  (option) => (
                    <MenuItem value={option}>{option}</MenuItem>
                  )
                )}
              </Select>
              {subject === "Custom" && (
                <TextField
                  label="Custom Subject"
                  variant="outlined"
                  color="success"
                  InputProps={{
                    inputProps: {
                      maxLength: 50,
                    },
                  }}
                  fullWidth
                  className={classes.textField}
                  value={customSubject}
                  onChange={(e) => setCustomSubject(e.target.value)}
                />
              )}
            </FormControl>
            <TextField
              label="Answer"
              variant="outlined"
              multiline
              rows={3}
              className={classes.textField}
              fullWidth
              placeholder="Maximum of 1000 characters"
              InputProps={{
                inputProps: {
                  maxLength: 1000,
                },
              }}
              style={{ marginTop: "15px" }}
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
            />
          </div>
          <div className={classes.modalActions}>
            <Stack spacing={2} direction="row">
              <div className={classes.modalActions} style={{}}>
                <Button
                  color="success"
                  variant="contained"
                  style={{ fontWeight: "bold", color: "#fff" }}
                  onClick={handleSave}>
                  Save
                </Button>

                <Button
                  variant="outlined"
                  style={{ color: "#FF0000", marginLeft: "10px" }}
                  onClick={onClose}>
                  Cancel
                </Button>
              </div>
            </Stack>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default AddFAQ;
